<section class="modal__buttons">
  <ui-icon class="modal__close" name="arrow_back" (click)="dialogRef.closeAll()"></ui-icon>
</section>
<div class="scrollbar">
  <section class="modal__body">
    <ui-text
      align="center"
      *ngIf="title"
      class="modal__title"
      weight="semibold"
      size="h4"
      color="blue-500"
    >
      {{ title }}
    </ui-text>
    <ng-content></ng-content>
  </section>
</div>
